import React from 'react';

interface Props {
    isSellout: boolean
}

export class IsSellout extends React.Component<Props, {}> {


    render() {
        let isSellout: boolean = this.props.isSellout

        return (
            <>
                {isSellout ? <span  className="sellout-sticker" style={{marginTop: 8}}>Распродажа</span> : null}
            </>
        )
    }
}

